import {
  WebSocketSessionzi1ianvyj32u as WebSocketSession,
  close1aubkxuq1mzed as close,
  closeExceptionally2ucrayfvrq1dt as closeExceptionally,
  send1afreql7wqu1y as send,
} from './WebSocketSession.mjs';
import {
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  Companion_getInstance1pwau9pkopj as Companion_getInstance,
  from3gpkuvfyl3bft as from,
  ChannelOverflow_SUSPEND_getInstance3eboo9op8vilj as ChannelOverflow_SUSPEND_getInstance,
  ChannelConfigftdbykui5s0q as ChannelConfig,
} from './WebSocketChannelsConfig.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import {
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
} from '../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import {
  toString1pkumu07cwy4m as toString,
  protoOf180f3jzyo7rfj as protoOf,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { Dispatchers_getInstance128lm494a5r5s as Dispatchers_getInstance } from '../../../../kotlinx-coroutines-core/kotlinx/coroutines/Dispatchers.mjs';
import { launch1c91vkjzdi9sd as launch } from '../../../../kotlinx-coroutines-core/kotlinx/coroutines/Builders.common.mjs';
import { CoroutineStart_UNDISPATCHED_getInstance36t7e2kqqnuqp as CoroutineStart_UNDISPATCHED_getInstance } from '../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineStart.mjs';
import { get_isTraceEnabled82xibuu04nxp as get_isTraceEnabled } from '../../../../ktor-ktor-utils/io/ktor/util/logging/Logger.web.mjs';
import {
  Binary3tlzyfojm51s4 as Binary,
  Text3e6ukp9joohql as Text,
  Close3tx65evcwi73t as Close,
  Pong3m3cas9hmc9ec as Pong,
  Companion_getInstance3acdrc353k3ou as Companion_getInstance_0,
  Ping3nta6l7sdq1r9 as Ping,
} from './Frame.nonJvm.mjs';
import {
  readReason2qq1b0s02pdpy as readReason,
  NonDisposableHandle_instance32d73uqknj6a6 as NonDisposableHandle_instance,
} from './FrameCommon.mjs';
import { toString30pk9tzaqopn as toString_0 } from '../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import {
  CloseReason10cphaqpp3ct7 as CloseReason,
  Codes_NORMAL_getInstance3dr9ood98owg7 as Codes_NORMAL_getInstance,
  Codes_CLOSED_ABNORMALLY_getInstance1bzb878jpjbg8 as Codes_CLOSED_ABNORMALLY_getInstance,
  Codes_TOO_BIG_getInstance1w6i1sh1qah29 as Codes_TOO_BIG_getInstance,
} from './CloseReason.mjs';
import {
  pingerd16zvjbf6m9o as pinger,
  ponger270tezdl2mu68 as ponger,
} from './PingPong.mjs';
import {
  ChannelResult2y4k69ac6y3du as ChannelResult,
  _ChannelResult___get_isSuccess__impl__odq1z923tdiqn4dmkwh as _ChannelResult___get_isSuccess__impl__odq1z9,
  ClosedSendChannelException29m33prpq9jaw as ClosedSendChannelException,
  ClosedReceiveChannelException3ofg6gf5f5b38 as ClosedReceiveChannelException,
  Factory_getInstance14vrned6uf29d as Factory_getInstance,
} from '../../../../kotlinx-coroutines-core/kotlinx/coroutines/channels/Channel.mjs';
import {
  get_size2imoy2jq11jxl as get_size,
  BytePacketBuilder2biodf4wxvlba as BytePacketBuilder,
  writeFully359t6q8kam2g5 as writeFully,
  buildjygoh729rhy8 as build,
} from '../../../../ktor-ktor-io/io/ktor/utils/io/core/BytePacketBuilder.mjs';
import { FrameTooBigException1rgdafsgu31sm as FrameTooBigException } from './FrameTooBigException.mjs';
import { fromInt2ii0rejb1w62w as fromInt } from '../../../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
import { orPromise1iucc2to2udt2 as orPromise } from '../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/coroutinesInteropJs.mjs';
import { constructCallableReference23y65rf941mch as constructCallableReference } from '../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { ensureNotNull1e947j3ixpazm as ensureNotNull } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { readByteArray1ri21h2rciakw as readByteArray } from '../../../../kotlinx-io-kotlinx-io-core/kotlinx/io/Sources.mjs';
import { cancelConsumed2i0oizqhmljf6 as cancelConsumed } from '../../../../kotlinx-coroutines-core/kotlinx/coroutines/channels/Channels.common.mjs';
import { CancellationException3b36o9qz53rgr as CancellationException } from '../../../../kotlin-kotlin-stdlib/kotlin/coroutines/cancellation/CancellationException.mjs';
import { ChannelIOException2i3t76lsrbgox as ChannelIOException } from '../../../../ktor-ktor-utils/io/ktor/util/cio/Channels.mjs';
import { IOException1wyutdmfe71nu as IOException } from '../../../../kotlinx-io-kotlinx-io-core/kotlinx/io/-PlatformJs.mjs';
import {
  atomic$ref$130aurmcwdfdf1 as atomic$ref$1,
  atomic$boolean$1iggki4z65a2h as atomic$boolean$1,
} from '../../../../kotlinx-atomicfu/kotlinx/atomicfu/AtomicFU.mjs';
import { CompletableDeferred2lnqvsbvx74d3 as CompletableDeferred } from '../../../../kotlinx-coroutines-core/kotlinx/coroutines/CompletableDeferred.mjs';
import {
  Job13y4jkazwjho0 as Job,
  Key_instancepi2bbb0csu5f as Key_instance,
} from '../../../../kotlinx-coroutines-core/kotlinx/coroutines/Job.mjs';
import { CoroutineName2g5zosw74tf0f as CoroutineName } from '../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineName.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { joinToString1cxrrlmo0chqs as joinToString } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { KtorSimpleLogger1xdphsp5l4e48 as KtorSimpleLogger } from '../../../../ktor-ktor-utils/io/ktor/util/logging/KtorSimpleLogger.web.mjs';
import { get_OUTGOING_CHANNEL_CAPACITY2ancx42jsldm9 as get_OUTGOING_CHANNEL_CAPACITY } from './Utils.nonJvm.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_LOGGER() {
  _init_properties_DefaultWebSocketSession_kt__469s0y();
  return LOGGER;
}
var LOGGER;
function get_IncomingProcessorCoroutineName() {
  _init_properties_DefaultWebSocketSession_kt__469s0y();
  return IncomingProcessorCoroutineName;
}
var IncomingProcessorCoroutineName;
function get_OutgoingProcessorCoroutineName() {
  _init_properties_DefaultWebSocketSession_kt__469s0y();
  return OutgoingProcessorCoroutineName;
}
var OutgoingProcessorCoroutineName;
function get_NORMAL_CLOSE() {
  _init_properties_DefaultWebSocketSession_kt__469s0y();
  return NORMAL_CLOSE;
}
var NORMAL_CLOSE;
var OUTGOING_CHANNEL_CONFIG;
var DefaultWebSocketSessionClass;
function DefaultWebSocketSession() {
  if (DefaultWebSocketSessionClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'DefaultWebSocketSession', VOID, VOID, [WebSocketSession()], [1, 0]);
    DefaultWebSocketSessionClass = $;
  }
  return DefaultWebSocketSessionClass;
}
function DefaultWebSocketSession_0(session, pingIntervalMillis, timeoutMillis, channelsConfig) {
  pingIntervalMillis = pingIntervalMillis === VOID ? 0n : pingIntervalMillis;
  timeoutMillis = timeoutMillis === VOID ? 15000n : timeoutMillis;
  channelsConfig = channelsConfig === VOID ? Companion_getInstance().UNLIMITED_1 : channelsConfig;
  _init_properties_DefaultWebSocketSession_kt__469s0y();
  // Inline function 'kotlin.require' call
  if (!!isInterface(session, DefaultWebSocketSession())) {
    var message = 'Cannot wrap other DefaultWebSocketSession';
    throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$(toString(message));
  }
  return new (DefaultWebSocketSessionImpl())(session, pingIntervalMillis, timeoutMillis, channelsConfig.incoming_1, channelsConfig.outgoing_1);
}
function runIncomingProcessor($this, ponger) {
  var tmp = get_IncomingProcessorCoroutineName().plus_s13ygv_k$(Dispatchers_getInstance().Unconfined_1);
  return launch($this, tmp, VOID, DefaultWebSocketSessionImpl$runIncomingProcessor$slambda($this, ponger));
}
function runOutgoingProcessor($this) {
  var tmp = get_OutgoingProcessorCoroutineName().plus_s13ygv_k$(Dispatchers_getInstance().Unconfined_1);
  var tmp_0 = CoroutineStart_UNDISPATCHED_getInstance();
  return launch($this, tmp, tmp_0, DefaultWebSocketSessionImpl$runOutgoingProcessor$slambda($this));
}
function *outgoingProcessorLoop($this, $completion) {
  var _iterator__ex2g4s = $this.outgoingToBeProcessed_1.iterator_jk1svi_k$();
  $l$loop: while (yield* _iterator__ex2g4s.hasNext_nhy1w3_k$($completion)) {
    var frame = _iterator__ex2g4s.next_20eer_k$();
    // Inline function 'io.ktor.util.logging.trace' call
    var this_0 = get_LOGGER();
    if (get_isTraceEnabled(this_0)) {
      var tmp$ret$1 = 'Sending ' + frame.toString() + ' from session ' + toString($this);
      this_0.trace_fti9bv_k$(tmp$ret$1);
    }
    var tmp;
    if (frame instanceof Close()) {
      yield* sendCloseSequence($this, readReason(frame), VOID, $completion);
      break $l$loop;
    } else {
      var tmp_0;
      if (frame instanceof Text()) {
        tmp_0 = true;
      } else {
        tmp_0 = frame instanceof Binary();
      }
      if (tmp_0) {
        tmp = processOutgoingExtensions($this, frame);
      } else {
        tmp = frame;
      }
    }
    var processedFrame = tmp;
    yield* $this.raw_1.get_outgoing_us7o3v_k$().send_44jogj_k$(processedFrame, $completion);
  }
  return Unit_instance;
}
function *sendCloseSequence($this, reason, exception, $completion) {
  exception = exception === VOID ? null : exception;
  if (!tryClose($this))
    return Unit_instance;
  // Inline function 'io.ktor.util.logging.trace' call
  var this_0 = get_LOGGER();
  if (get_isTraceEnabled(this_0)) {
    var tmp$ret$1 = 'Sending Close Sequence for session ' + toString($this) + ' with reason ' + toString_0(reason) + ' and exception ' + toString_0(exception);
    this_0.trace_fti9bv_k$(tmp$ret$1);
  }
  $this.context_1.complete_9ww6vb_k$();
  var reasonToSend = reason == null ? CloseReason().new_io_ktor_websocket_CloseReason_al0vxu_k$(Codes_NORMAL_getInstance(), '') : reason;
  try {
    runOrCancelPinger($this);
    if (!(reasonToSend.code_1 === Codes_CLOSED_ABNORMALLY_getInstance().code_1)) {
      yield* $this.raw_1.get_outgoing_us7o3v_k$().send_44jogj_k$(Close().new_io_ktor_websocket_Frame_Close_zgly5v_k$(reasonToSend), $completion);
    }
  }finally {
    $this.closeReasonRef_1.complete_ixf84q_k$(reasonToSend);
    if (!(exception == null)) {
      $this.outgoingToBeProcessed_1.close_ukldxa_k$(exception);
      $this.filtered_1.close_ukldxa_k$(exception);
    }
  }
  return Unit_instance;
}
function tryClose($this) {
  return $this.closed_1.atomicfu$compareAndSet(false, true);
}
function runOrCancelPinger($this) {
  var interval = $this.pingIntervalMillis_1;
  var tmp;
  if ($this.closed_1.kotlinx$atomicfu$value) {
    tmp = null;
  } else if (interval > 0n) {
    var tmp_0 = $this.raw_1.get_outgoing_us7o3v_k$();
    var tmp_1 = $this.timeoutMillis_1;
    tmp = pinger($this, tmp_0, interval, tmp_1, DefaultWebSocketSessionImpl$runOrCancelPinger$slambda($this));
  } else {
    tmp = null;
  }
  var newPinger = tmp;
  var tmp0_safe_receiver = $this.pinger_1.atomicfu$getAndSet(newPinger);
  if (tmp0_safe_receiver == null)
    null;
  else
    tmp0_safe_receiver.close$default_kcbl7u_k$();
  var tmp2_safe_receiver = newPinger == null ? null : new (ChannelResult())(newPinger.trySend_62dpg8_k$(Companion_getInstance_1().EmptyPong_1));
  if (tmp2_safe_receiver == null)
    null;
  else
    _ChannelResult___get_isSuccess__impl__odq1z9(tmp2_safe_receiver.holder_1);
  if ($this.closed_1.kotlinx$atomicfu$value && !(newPinger == null)) {
    runOrCancelPinger($this);
  }
}
function *checkMaxFrameSize($this, packet, frame, $completion) {
  var tmp = frame.data_1.length;
  var tmp1_elvis_lhs = packet == null ? null : get_size(packet);
  var size = tmp + (tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs) | 0;
  if (fromInt(size) > $this.get_maxFrameSize_9zaht9_k$()) {
    if (packet == null)
      null;
    else {
      packet.close_yn9xrc_k$();
    }
    yield* close($this, CloseReason().new_io_ktor_websocket_CloseReason_al0vxu_k$(Codes_TOO_BIG_getInstance(), 'Frame is too big: ' + size + '. Max size is ' + $this.get_maxFrameSize_9zaht9_k$().toString()), $completion);
    throw FrameTooBigException().new_io_ktor_websocket_FrameTooBigException_7tb0yi_k$(fromInt(size));
  }
  return Unit_instance;
}
function processIncomingExtensions($this, frame) {
  // Inline function 'kotlin.collections.fold' call
  var accumulator = frame;
  var _iterator__ex2g4s = $this.get_extensions_kxksyl_k$().iterator_jk1svi_k$();
  while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
    var element = _iterator__ex2g4s.next_20eer_k$();
    var current = accumulator;
    accumulator = element.processIncomingFrame_lcwqbj_k$(current);
  }
  return accumulator;
}
function processOutgoingExtensions($this, frame) {
  // Inline function 'kotlin.collections.fold' call
  var accumulator = frame;
  var _iterator__ex2g4s = $this.get_extensions_kxksyl_k$().iterator_jk1svi_k$();
  while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
    var element = _iterator__ex2g4s.next_20eer_k$();
    var current = accumulator;
    accumulator = element.processOutgoingFrame_8xceij_k$(current);
  }
  return accumulator;
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        this.EmptyPong_1 = Pong().new_io_ktor_websocket_Frame_Pong_hee4xw_k$(new Int8Array(0), NonDisposableHandle_instance);
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance_1() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
function DefaultWebSocketSessionImpl$start$slambda($incomingJob, $outgoingJob, this$0) {
  return constructCallableReference(($this$launch, $completion) => orPromise($completion, function *($completion) {
    yield* $incomingJob.join_o20dar_k$($completion);
    yield* $outgoingJob.join_o20dar_k$($completion);
    this$0.context_1.cancel$default_8haxne_k$();
    return Unit_instance;
  }), 1);
}
function DefaultWebSocketSessionImpl$runIncomingProcessor$slambda(this$0, $ponger) {
  return constructCallableReference(($this$launch, $completion) => orPromise($completion, function *($completion) {
    var firstFrame = null;
    var frameBody = null;
    var closeFramePresented = false;
    try {
      // Inline function 'kotlinx.coroutines.channels.consumeEach' call
      var tmp0 = this$0.raw_1.get_incoming_u9os29_k$();
      $l$block_1: {
        // Inline function 'kotlinx.coroutines.channels.consume' call
        var cause = null;
        try {
          var _iterator__ex2g4s = tmp0.iterator_jk1svi_k$();
          while (yield* _iterator__ex2g4s.hasNext_nhy1w3_k$($completion)) {
            var e = _iterator__ex2g4s.next_20eer_k$();
            $l$block_0: {
              // Inline function 'io.ktor.util.logging.trace' call
              var this_0 = get_LOGGER();
              if (get_isTraceEnabled(this_0)) {
                var tmp$ret$5 = 'WebSocketSession(' + toString($this$launch) + ') receiving frame ' + e.toString();
                this_0.trace_fti9bv_k$(tmp$ret$5);
              }
              if (e instanceof Close()) {
                if (!this$0.get_outgoing_us7o3v_k$().get_isClosedForSend_ajczci_k$()) {
                  var tmp = this$0.get_outgoing_us7o3v_k$();
                  var tmp1_elvis_lhs = readReason(e);
                  yield* tmp.send_44jogj_k$(Close().new_io_ktor_websocket_Frame_Close_zgly5v_k$(tmp1_elvis_lhs == null ? get_NORMAL_CLOSE() : tmp1_elvis_lhs), $completion);
                }
                closeFramePresented = true;
                return Unit_instance;
              } else {
                if (e instanceof Pong()) {
                  var tmp2_safe_receiver = this$0.pinger_1.kotlinx$atomicfu$value;
                  if (tmp2_safe_receiver == null)
                    null;
                  else
                    yield* tmp2_safe_receiver.send_44jogj_k$(e, $completion);
                } else {
                  if (e instanceof Ping())
                    yield* $ponger.send_44jogj_k$(e, $completion);
                  else {
                    yield* /*#__NOINLINE__*/checkMaxFrameSize(this$0, frameBody, e, $completion);
                    if (!e.fin_1) {
                      if (firstFrame == null) {
                        firstFrame = e;
                      }
                      if (frameBody == null) {
                        frameBody = BytePacketBuilder();
                      }
                      writeFully(frameBody, e.data_1);
                      break $l$block_0;
                    }
                    if (firstFrame == null) {
                      yield* this$0.filtered_1.send_44jogj_k$(processIncomingExtensions(this$0, e), $completion);
                      break $l$block_0;
                    }
                    writeFully(ensureNotNull(frameBody), e.data_1);
                    var defragmented = Companion_getInstance_0().byType_2g4m5x_k$(true, firstFrame.frameType_1, readByteArray(build(frameBody)), firstFrame.rsv1__1, firstFrame.rsv2__1, firstFrame.rsv3__1);
                    firstFrame = null;
                    yield* this$0.filtered_1.send_44jogj_k$(processIncomingExtensions(this$0, defragmented), $completion);
                  }
                }
              }
            }
          }
          break $l$block_1;
        } catch ($p) {
          if ($p instanceof Error) {
            var e_0 = $p;
            cause = e_0;
            throw e_0;
          } else {
            throw $p;
          }
        }
        finally {
          cancelConsumed(tmp0, cause);
        }
      }
    } catch ($p_0) {
      if ($p_0 instanceof ClosedSendChannelException()) {
        var _unused_var__etf5q3 = $p_0;
      } else {
        if ($p_0 instanceof Error) {
          var cause_0 = $p_0;
          $ponger.close$default_kcbl7u_k$();
          this$0.filtered_1.close_ukldxa_k$(cause_0);
        } else {
          throw $p_0;
        }
      }
    }
    finally {
      $ponger.close$default_kcbl7u_k$();
      var tmp0_safe_receiver = frameBody;
      if (tmp0_safe_receiver == null)
        null;
      else {
        tmp0_safe_receiver.close_yn9xrc_k$();
      }
      this$0.filtered_1.close$default_kcbl7u_k$();
      if (!closeFramePresented) {
        yield* close(this$0, CloseReason().new_io_ktor_websocket_CloseReason_al0vxu_k$(Codes_CLOSED_ABNORMALLY_getInstance(), 'Connection was closed without close frame'), $completion);
      }
    }
    return Unit_instance;
  }), 1);
}
function DefaultWebSocketSessionImpl$runOutgoingProcessor$slambda(this$0) {
  return constructCallableReference(($this$launch, $completion) => orPromise($completion, function *($completion) {
    var tmp;
    try {
      tmp = yield* /*#__NOINLINE__*/outgoingProcessorLoop(this$0, $completion);
    } catch ($p) {
      var tmp_0;
      if ($p instanceof ClosedSendChannelException()) {
        var _unused_var__etf5q3 = $p;
        tmp_0 = Unit_instance;
      } else {
        if ($p instanceof ClosedReceiveChannelException()) {
          var _unused_var__etf5q3_0 = $p;
          tmp_0 = Unit_instance;
        } else {
          if ($p instanceof CancellationException()) {
            var _unused_var__etf5q3_1 = $p;
            tmp_0 = yield* /*#__NOINLINE__*/sendCloseSequence(this$0, CloseReason().new_io_ktor_websocket_CloseReason_al0vxu_k$(Codes_NORMAL_getInstance(), ''), VOID, $completion);
          } else {
            if ($p instanceof ChannelIOException()) {
              var _unused_var__etf5q3_2 = $p;
              tmp_0 = Unit_instance;
            } else {
              if ($p instanceof Error) {
                var cause = $p;
                this$0.outgoingToBeProcessed_1.cancel_hkmm2i_k$(CancellationException().new_kotlin_coroutines_cancellation_CancellationException_cpsifs_k$('Failed to send frame', cause));
                yield* closeExceptionally(this$0.raw_1, cause, $completion);
                return Unit_instance;
              } else {
                throw $p;
              }
            }
          }
        }
      }
      tmp = tmp_0;
    }
    finally {
      this$0.outgoingToBeProcessed_1.cancel$default_880p35_k$();
      yield* close(this$0.raw_1, VOID, $completion);
    }
    return Unit_instance;
  }), 1);
}
function DefaultWebSocketSessionImpl$runOrCancelPinger$slambda(this$0) {
  return constructCallableReference((it, $completion) => orPromise($completion, function *($completion) {
    yield* /*#__NOINLINE__*/sendCloseSequence(this$0, it, IOException().new_kotlinx_io_IOException_wvwdyo_k$('Ping timeout'), $completion);
    return Unit_instance;
  }), 1);
}
var DefaultWebSocketSessionImplClass;
function DefaultWebSocketSessionImpl() {
  if (DefaultWebSocketSessionImplClass === VOID) {
    class $ {
      constructor(raw, pingIntervalMillis, timeoutMillis, incomingFramesConfig, outgoingFramesConfig) {
        Companion_getInstance_1();
        this.raw_1 = raw;
        this.pinger_1 = atomic$ref$1(null);
        this.closeReasonRef_1 = CompletableDeferred();
        this.context_1 = Job();
        this.coroutineContext_1 = this.raw_1.get_coroutineContext_115oqo_k$().minusKey_9i5ggf_k$(Key_instance).plus_s13ygv_k$(this.context_1).plus_s13ygv_k$(new (CoroutineName())('ws-default'));
        this.filtered_1 = from(Factory_getInstance(), incomingFramesConfig);
        this.outgoingToBeProcessed_1 = from(Factory_getInstance(), outgoingFramesConfig);
        this.closed_1 = atomic$boolean$1(false);
        var tmp = this;
        // Inline function 'kotlin.collections.mutableListOf' call
        tmp._extensions_1 = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
        this.started_1 = atomic$boolean$1(false);
        this.pingIntervalMillis_1 = pingIntervalMillis;
        this.timeoutMillis_1 = timeoutMillis;
        this.closeReason_1 = this.closeReasonRef_1;
      }
      get_coroutineContext_115oqo_k$() {
        return this.coroutineContext_1;
      }
      get_incoming_u9os29_k$() {
        return this.filtered_1;
      }
      get_outgoing_us7o3v_k$() {
        return this.outgoingToBeProcessed_1;
      }
      get_extensions_kxksyl_k$() {
        return this._extensions_1;
      }
      set_maxFrameSize_k27os3_k$(value) {
        this.raw_1.set_maxFrameSize_k27os3_k$(value);
      }
      get_maxFrameSize_9zaht9_k$() {
        return this.raw_1.get_maxFrameSize_9zaht9_k$();
      }
      get_closeReason_g1m41f_k$() {
        return this.closeReason_1;
      }
      start_ye6294_k$(negotiatedExtensions) {
        if (!this.started_1.atomicfu$compareAndSet(false, true)) {
          // Inline function 'kotlin.error' call
          var message = 'WebSocket session ' + toString(this) + ' is already started.';
          throw IllegalStateException().new_kotlin_IllegalStateException_w47ei6_k$(toString(message));
        }
        // Inline function 'io.ktor.util.logging.trace' call
        var this_0 = get_LOGGER();
        if (get_isTraceEnabled(this_0)) {
          var tmp$ret$2 = 'Starting default WebSocketSession(' + toString(this) + ') ' + ('with negotiated extensions: ' + joinToString(negotiatedExtensions));
          this_0.trace_fti9bv_k$(tmp$ret$2);
        }
        this._extensions_1.addAll_h3ej1q_k$(negotiatedExtensions);
        runOrCancelPinger(this);
        var incomingJob = runIncomingProcessor(this, ponger(this, this.get_outgoing_us7o3v_k$()));
        var outgoingJob = runOutgoingProcessor(this);
        launch(this, VOID, VOID, DefaultWebSocketSessionImpl$start$slambda(incomingJob, outgoingJob, this));
      }
      *flush_4wsz1p_k$($completion) {
        yield* this.raw_1.flush_4wsz1p_k$($completion);
        return Unit_instance;
      }
    }
    protoOf($).send_sburzs_k$ = send;
    initMetadataForClass($, 'DefaultWebSocketSessionImpl', VOID, VOID, [DefaultWebSocketSession(), WebSocketSession()], [1, 0, 2]);
    DefaultWebSocketSessionImplClass = $;
  }
  return DefaultWebSocketSessionImplClass;
}
var properties_initialized_DefaultWebSocketSession_kt_6cjlhc;
function _init_properties_DefaultWebSocketSession_kt__469s0y() {
  if (!properties_initialized_DefaultWebSocketSession_kt_6cjlhc) {
    properties_initialized_DefaultWebSocketSession_kt_6cjlhc = true;
    LOGGER = KtorSimpleLogger('io.ktor.websocket.WebSocket');
    IncomingProcessorCoroutineName = new (CoroutineName())('ws-incoming-processor');
    OutgoingProcessorCoroutineName = new (CoroutineName())('ws-outgoing-processor');
    NORMAL_CLOSE = CloseReason().new_io_ktor_websocket_CloseReason_al0vxu_k$(Codes_NORMAL_getInstance(), 'OK');
    var tmp0_safe_receiver = get_OUTGOING_CHANNEL_CAPACITY();
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp = new (ChannelConfig())(tmp0_safe_receiver, ChannelOverflow_SUSPEND_getInstance());
    }
    OUTGOING_CHANNEL_CONFIG = tmp;
  }
}
//region block: exports
export {
  DefaultWebSocketSession_0 as DefaultWebSocketSessionmehckluw85jl,
  DefaultWebSocketSession as DefaultWebSocketSession3h8506yqzs5fx,
  get_LOGGER as get_LOGGER1pnacb4n2g1eb,
};
//endregion

//# sourceMappingURL=DefaultWebSocketSession.mjs.map
